import CargoCompanyOrderBillingsListRequest, {
  CargoCompanyOrderBillingsListRequestOrder,
  CargoCompanyOrderBillingsListRequestStatus,
} from "../../../../api/raily/cargo-company/order-billings/list/cargo-company-order-billings-list.request";
import BillingStatus from "../../../../types/billing-status";
import CargoCompanyOrder from "../../../../types/cargo-company-order";
import CargoCompanyOrderBillingsListParams from "./cargo-company-order-billings-list-params";

const createStatus = (
  status: BillingStatus | undefined,
): CargoCompanyOrderBillingsListRequestStatus | undefined => {
  switch (status) {
    case BillingStatus.ACCEPTED:
      return CargoCompanyOrderBillingsListRequestStatus.ACCEPTED;
    case BillingStatus.CREATED:
      return CargoCompanyOrderBillingsListRequestStatus.CREATED;
    case BillingStatus.REJECTED:
      return CargoCompanyOrderBillingsListRequestStatus.REJECTED;
    case BillingStatus.REOPENED:
      return CargoCompanyOrderBillingsListRequestStatus.REOPENED;
    case BillingStatus.REOPEN_REQUEST:
      return CargoCompanyOrderBillingsListRequestStatus.REOPEN_REQUEST_SENT;
  }
};

const createOrder = (
  order: CargoCompanyOrder | undefined,
): CargoCompanyOrderBillingsListRequestOrder | undefined => {
  switch (order) {
    case CargoCompanyOrder.DATE_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.DATE_ASC;
    case CargoCompanyOrder.DATE_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.DATE_DESC;
    case CargoCompanyOrder.DISCOUNT_AMOUNT_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.DISCOUNT_AMOUNT_ASC;
    case CargoCompanyOrder.DISCOUNT_AMOUNT_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.DISCOUNT_AMOUNT_DESC;
    case CargoCompanyOrder.DISCOUNT_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.DISCOUNT_ASC;
    case CargoCompanyOrder.DISCOUNT_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.DISCOUNT_DESC;
    case CargoCompanyOrder.DISPATCH_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.DISPATCH_ASC;
    case CargoCompanyOrder.DISPATCH_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.DISPATCH_DESC;
    case CargoCompanyOrder.DISTANCE_AMOUNT_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.DISTANCE_AMOUNT_ASC;
    case CargoCompanyOrder.DISTANCE_AMOUNT_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.DISTANCE_AMOUNT_DESC;
    case CargoCompanyOrder.DISTANCE_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.DISTANCE_ASC;
    case CargoCompanyOrder.DISTANCE_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.DISTANCE_DESC;
    case CargoCompanyOrder.DISTANCE_RATE_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.DISTANCE_RATE_ASC;
    case CargoCompanyOrder.DISTANCE_RATE_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.DISTANCE_RATE_DESC;
    case CargoCompanyOrder.EXTERNAL_ORDER_ID_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.EXTERNAL_ORDER_ID_ASC;
    case CargoCompanyOrder.EXTERNAL_ORDER_ID_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.EXTERNAL_ORDER_ID_DESC;
    case CargoCompanyOrder.HALTING_AMOUNT_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.HALTING_AMOUNT_ASC;
    case CargoCompanyOrder.HALTING_AMOUNT_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.HALTING_AMOUNT_DESC;
    case CargoCompanyOrder.HALTING_HOURS_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.HALTING_HOURS_ASC;
    case CargoCompanyOrder.HALTING_HOURS_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.HALTING_HOURS_DESC;
    case CargoCompanyOrder.HIGHWAY_CHARGE_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.HIGHWAY_CHARGE_ASC;
    case CargoCompanyOrder.HIGHWAY_CHARGE_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.HIGHWAY_CHARGE_DESC;
    case CargoCompanyOrder.HUMAN_ID_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.HUMAN_ID_ASC;
    case CargoCompanyOrder.HUMAN_ID_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.HUMAN_ID_DESC;
    case CargoCompanyOrder.TAXI_CORPORATION_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.TAXI_CORPORATION_ASC;
    case CargoCompanyOrder.TAXI_CORPORATION_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.TAXI_CORPORATION_DESC;
    case CargoCompanyOrder.TOTAL_AMOUNT_ASC:
      return CargoCompanyOrderBillingsListRequestOrder.TOTAL_AMOUNT_ASC;
    case CargoCompanyOrder.TOTAL_AMOUNT_DESC:
      return CargoCompanyOrderBillingsListRequestOrder.TOTAL_AMOUNT_DESC;
  }
};

const create = (
  params: CargoCompanyOrderBillingsListParams,
): CargoCompanyOrderBillingsListRequest => {
  return {
    cargoCompanyUuid: params.cargoCompanyUuid,
    limit: params.limit,
    offset: params.offset,
    address: params.address,
    dateSince: params.dateSince,
    dateTo: params.dateTo,
    dispatch: params.dispatch,
    endAddress: params.endAddress,
    externalId: params.externalId,
    humanId: params.humanId,
    midAddress: params.midAddress,
    order: createOrder(params.order),
    passenger: params.passenger,
    startAddress: params.startAddress,
    status: createStatus(params.status),
    taxi: params.taxi,
  };
};

const cargoCompanyOrderBillingsListParamsFactory = {
  create,
};

export default cargoCompanyOrderBillingsListParamsFactory;
